module.exports = __webpack_public_path__ + "static/media/accumulate.5eec591e.png";